const convertToKST = (date) => {
    if (!(date instanceof Date) || isNaN(date.getTime())) {
        console.error("Invalid date passed to convertToKST:", date);
        return null;
    }

    const options = {
        timeZone: "Asia/Seoul",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
    };
    return new Intl.DateTimeFormat("ko-KR", options).format(date).replace(/\//g, "-");
};

export default convertToKST;
